const DEFAULT_LOCALE =  'en_GB';

export default (flowConfigLocales) => {
  const ppfUrl = new URL(window.location.href);
  const { origin, search, pathname } = ppfUrl;
  const [, locale, environment, learnLang, flowId, node, nodeIndex] = pathname.split('/');
  if (!flowConfigLocales.includes(locale) && learnLang && flowId) {
    window.location.replace(
      `${origin}/${DEFAULT_LOCALE}/${environment}/${learnLang}/${flowId}/${node}/${nodeIndex}${search}`
    );
  }
};
